import type { DynamicIslandAccent, DynamicIslandLifecycle } from '../../context/dynamicIslandTypes'
import {
  episodeQueueProgressFillClass,
  episodeQueueProgressTrackClass,
} from '../episodeQueueTimelineTheme'

export function dynamicIslandAccentClass(accent: DynamicIslandAccent): string {
  return `glyphicai-dynamic-island-activity__accent--${accent}`
}

export function dynamicIslandProgressFillClass(opts: {
  accent: DynamicIslandAccent
  progressPercent: number
  lifecycle?: DynamicIslandLifecycle
}): string {
  const { accent, progressPercent, lifecycle } = opts
  if (accent === 'cancelled') {
    return episodeQueueProgressFillClass({ cancelled: true, finished: false, hasFailed: false, inProgress: false })
  }
  const terminal = lifecycle === 'terminal'
  return episodeQueueProgressFillClass({
    cancelled: false,
    finished: terminal || (accent === 'success' && progressPercent >= 100),
    hasFailed: accent === 'danger',
    inProgress: !terminal && (accent === 'warn' || accent === 'muted'),
  })
}

export function dynamicIslandStatusChipClass(accent: DynamicIslandAccent): string {
  const semantic =
    accent === 'danger'
      ? 'failed'
      : accent === 'success'
        ? 'done'
        : accent === 'cancelled'
          ? 'cancelled'
          : accent === 'warn'
            ? 'running'
            : 'pending'
  return [
    'inline-flex min-w-[3rem] shrink-0 items-center justify-center rounded-full border px-1.5 py-px text-[9px] font-bold uppercase tracking-wide',
    semantic === 'failed'
      ? 'border-[color-mix(in_srgb,var(--timeline-rail-danger)_34%,var(--line)_66%)] bg-[color-mix(in_srgb,var(--timeline-rail-danger)_11%,var(--panel)_89%)] text-[color-mix(in_srgb,var(--timeline-rail-danger)_58%,var(--ink)_42%)]'
      : semantic === 'done'
        ? 'border-[color-mix(in_srgb,var(--timeline-rail-success)_34%,var(--line)_66%)] bg-[color-mix(in_srgb,var(--timeline-rail-success)_11%,var(--panel)_89%)] text-[color-mix(in_srgb,var(--timeline-rail-success)_58%,var(--ink)_42%)]'
        : semantic === 'cancelled'
          ? 'border-[color-mix(in_srgb,var(--timeline-rail-cancelled)_34%,var(--line)_66%)] bg-[color-mix(in_srgb,var(--timeline-rail-cancelled)_11%,var(--panel)_89%)] text-[color-mix(in_srgb,var(--timeline-rail-cancelled)_58%,var(--ink)_42%)]'
          : semantic === 'running'
            ? 'border-[color-mix(in_srgb,var(--timeline-rail-warn)_34%,var(--line)_66%)] bg-[color-mix(in_srgb,var(--timeline-rail-warn)_11%,var(--panel)_89%)] text-[color-mix(in_srgb,var(--timeline-rail-warn)_58%,var(--ink)_42%)]'
            : 'border-[color-mix(in_srgb,var(--timeline-rail-muted)_34%,var(--line)_66%)] bg-[color-mix(in_srgb,var(--timeline-rail-muted)_11%,var(--panel)_89%)] text-[color-mix(in_srgb,var(--timeline-rail-muted)_58%,var(--ink)_42%)]',
  ].join(' ')
}

export function dynamicIslandSourceTagClass(): string {
  return 'inline-flex shrink-0 items-center rounded-full border border-line/80 bg-surface px-1.5 py-px text-[9px] font-bold uppercase tracking-[0.06em] text-ink-soft'
}

export function dynamicIslandProgressTrackClass(angular: boolean): string {
  return ['glyphicai-dynamic-island-activity__progress', episodeQueueProgressTrackClass(angular)].join(' ')
}
